import Flickity from 'flickity-fullscreen'
import 'iframe-lightbox'

export const settings = {
  selector: '.c-property-spaces__overview-contact-us',
  contactButtonClass: 'js-property-spaces__overview-contact-us-button',
  select: '#property-contact .sponda-select-place select',
  toggleSlider: '.js-property-spaces__overview-image-trigger',
  selectSliders: '.js-property-spaces__overview-carousel',
  selectSpaces: '.js-property-spaces__space',
  linkVirtualClass: 'js-property-spaces__virtual-tour-link',
  linkVirtualClass2: 'js-property-spaces__virtual-tour',
  navSelector: '.js-property-navigation',

  tabs: '.js-tabs',
  tabButton: '.js-tab-button',
  tabPabel: '.js-tab-panel'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {

  document.querySelectorAll( settings.tabs ).forEach(( tabGroup ) => {
    tabGroup.querySelectorAll( settings.tabButton ).forEach(( button ) => {
      button.addEventListener( 'click', () => {
        const tab = button.getAttribute( 'data-tab' )

        // Update buttons
        tabGroup.querySelectorAll( settings.tabButton ).forEach(( btn ) => {
          btn.classList.toggle( 'is-active', btn === button )
          btn.setAttribute( 'aria-selected', btn === button ? 'true' : 'false' )
        })

        // Show/hide panels
        tabGroup.querySelectorAll( settings.tabPabel ).forEach(( panel ) => {
          panel.hidden = panel.getAttribute( 'data-tab-content' ) !== tab
        })
      })
    })
  })

  let lightboxLinks = document.querySelectorAll( '.' + settings.linkVirtualClass2 )
  Array.from( lightboxLinks ).forEach(( el ) => {
    el.lightbox = new window.IframeLightbox( el )
  })

  let triggers = document.querySelectorAll( settings.toggleSlider )
  Array.from( triggers ).forEach(( trigger ) => {
    initCarouselTrigger( trigger )
  })

  let focusTriggers = document.querySelectorAll( settings.selectSpaces )
  Array.from( focusTriggers ).forEach(( trigger ) => {
    initFocusTrigger( trigger )
  })

  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {

    element.addEventListener( 'click', ( e ) => {
      let propertyId = e.target.dataset.propertyId
      let selectElement = document.querySelector( settings.select );

      [ ...selectElement.options ].some(( option, index ) => {
          if ( option.value == propertyId ) {
              selectElement.selectedIndex = index
              return true
          }
      })

      if ( typeof window.scroll === 'function' && typeof document.body.getBoundingClientRect === 'function' ) {

        const formSelector = '#' + e.target.href.split( '#' )[1]
        const form = document.querySelector( formSelector )

        if ( form ) {
          e.preventDefault()

          var bodyRect = document.body.getBoundingClientRect(),
              elemRect = form.getBoundingClientRect(),
              offset = elemRect.top - bodyRect.top

          window.scroll({
            top: offset,
            left: 0,
            behavior: 'smooth'
          })
        }
      }
    })
  })
}

/**
 *
 * @param {DOMNode} carouselEl
 */
function initCarousel( carouselEl ) {
  return new Flickity( carouselEl, {
    pageDots: false,
    prevNextButtons: true,
    cellSelector: '.carousel-cell',
    draggable: false,
    autoPlay: false,
    pauseAutoPlayOnHover: false,
    fullscreen: true,
    wrapAround: false,
    lazyLoad: 1,
    arrowShape: {
      x0: 20,
      x1: 70, y1: 40,
      x2: 70, y2: 0,
      x3: 70
    }
  })

  // carousel.toggleFullscreen()
  // console.log( carousel )
}

/**
 *
 * @param {DOMNode} trigger
 */
function initCarouselTrigger( trigger ) {
  trigger.addEventListener( 'click', function( e ) {
    e.preventDefault()
    const slider = e.target.parentNode.parentNode.querySelector( settings.selectSliders )
    const carousel = Flickity.data( slider ) || initCarousel( slider )
    carousel.toggleFullscreen()
    slider.focus()
  })
}

/**
 *
 * @param {DOMNode} trigger
 */
 function initFocusTrigger( trigger ) {
  trigger.addEventListener( 'click', function( e ) {
    if ( !e.target.classList.contains( settings.linkVirtualClass ) &&
    !e.target.classList.contains( settings.linkVirtualClass2 ) &&
    !e.target.classList.contains( settings.contactButtonClass )) {
      document.location.hash = e.target.closest( settings.selectSpaces ).id
    }
  }, true )
}
